// Every report page's "Reports" breadcrumb used to hardcode `to: "/"` —
// fine for office admins (no dedicated reports index to go back to), but
// wrong for ASM, who reaches every report through /manager/reports-hub
// and expects "Reports" to go back there, not to their Home dashboard.
import { useAuth } from "@/lib/auth";

export function useReportsBackLink() {
  const { user } = useAuth();
  return user?.role_code === "ASM" ? "/manager/reports-hub" : "/";
}
